import { render } from "./UmiHeader.vue?vue&type=template&id=4795ae85&scoped=true"
import script from "./UmiHeader.vue?vue&type=script&lang=js"
export * from "./UmiHeader.vue?vue&type=script&lang=js"

import "./UmiHeader.vue?vue&type=style&index=0&id=4795ae85&lang=scss&scoped=true"

import exportComponent from "/Users/umar/Desktop/umi-portfolio-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4795ae85"]])

export default __exports__